import { Injectable, PipeTransform } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, BehaviorSubject, Subject } from 'rxjs';
import { CategoriadeConteudo } from 'src/app/_models/categoria-conteudo';
import { SortDirection } from 'src/app/shared/sortable.directive';
import { tap, switchMap, debounceTime, delay, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface SearchResult {
	categoriadeconteudo: CategoriadeConteudo[];
	total: number;
}

interface State {
	page: number;
	pageSize: number;
	searchTerm: string;
	sortColumn: string;
	sortDirection: SortDirection;
}
/* const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json;charset=UTF-8',
    'Accept-Language': '1',
  }),
}; */

function compare(v1, v2) {
	return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
}

function sort(categoriadeconteudo: CategoriadeConteudo[], column: string, direction: string): CategoriadeConteudo[] {
	if (direction === '') {
		return categoriadeconteudo;
	} else {
		return [...categoriadeconteudo].sort((a, b) => {
			const res = compare(a[column], b[column]);
			return direction === 'asc' ? res : -res;
		});
	}
}

function matches(categoriadeconteudo: CategoriadeConteudo, term: string, pipe: PipeTransform) {
	return categoriadeconteudo.content.titles;
}


@Injectable({
	providedIn: 'root'
})

export class CategoriaConteudoService {


	private _loading$ = new BehaviorSubject<boolean>(true);
	private _search$ = new Subject<void>();
	private _categoriadeconteudo$ = new BehaviorSubject<CategoriadeConteudo[]>([]);
	private _total$ = new BehaviorSubject<number>(0);
	private categoriaCon: any;

	private _state: State = {
		page: 1,
		pageSize: 4,
		searchTerm: '',
		sortColumn: '',
		sortDirection: ''
	};

	constructor(
		private _http: HttpClient) {


		this._search$.next();
	}

	get total$() { return this._total$.asObservable(); }
	get loading$() { return this._loading$.asObservable(); }
	get page() { return this._state.page; }
	get pageSize() { return this._state.pageSize; }
	get searchTerm() { return this._state.searchTerm; }

	set page(page: number) { this._set({ page }); }
	set pageSize(pageSize: number) { this._set({ pageSize }); }
	set searchTerm(searchTerm: string) { this._set({ searchTerm }); }
	set sortColumn(sortColumn: string) { this._set({ sortColumn }); }
	set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

	private _set(patch: Partial<State>) {
		Object.assign(this._state, patch);
		this._search$.next();
	}


	// get categoriadeconteudo$() { return this._categoriadeconteudo$.asObservable(); }


	// ENDPOINTS ====================

	getContentCategory(language?: string, sort?: string, page?: any, size?: any, search?: string, status?: boolean, listAll?: boolean): Observable<any> {
		if (typeof page == 'number') page = String(page);
    	if (typeof size == 'number') size = String(size);
    	let params;

		if (search && search.length > 0) {
			params = {
				'page': page ? page : '',
				'size': size ? size : '',
				'search': search
			}
		} else {
			params = {
				'page': page ? page : '',
				'size': size ? size : '',
			}
		}

		if(status) {
			let isActive = true;
			if (sort === 'desc') {
				isActive = false;
			}
			params.orderByActive = isActive;
		} else {
			params.orderByInitial = `${language},${sort}`;
		}
		
		const url = environment.apiURL + '/content-categories' + (listAll ? '/all' : '');
		return this._http.get<CategoriadeConteudo[]>(url, { params: params });
	}


	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {

			console.error(error);

			return of(result as T);
		};
	}

	getCategoryById(id: number | string): Observable<any> {
		return this._http.get(`${environment.apiURL}/content-categories/${id}`)
	}

	getAllCategory(){
		return this._http.get(`${environment.apiURL}/content-categories/category`)
	}

	postCategory(category: any) {
		return this._http.post(`${environment.apiURL}/content-categories`, category)
	}

	putCategory(category: any) {
		return this._http.put(`${environment.apiURL}/content-categories/${category.id}`, category)
	}

	putCategoryId(category: any){
		return this._http.put(`${environment.apiURL}/content-categories/category`, category)
	}

	postCategoryAvatar(id: string | number, file: any, type: string) {
		if (typeof id == 'number') id = String(id)
		const formData = new FormData()
		formData.append('file', file)
		return this._http.post(`${environment.apiURL}/content-categories/${id}/avatar/${type}`, formData)
	}

	getLanguages(): Observable<any> {
		return this._http.get(`${environment.apiURL}/languages?translateApp=true`)
	}

	getFunctionality(id: number){
		return this._http.get(`${environment.apiURL}/functionality/${id}`)
	}

	postFunctionality(body: any) {
		return this._http.post(`${environment.apiURL}/functionality`, body)
	}

}
